import { createApp } from 'vue'
import Root from '@/App.vue'
const app = createApp(Root);
//------------------------------------------------ Store
import store from "@/middlewares/store";
app.use(store);
//------------------------------------------------ Router
import router from "@/middlewares/router";
app.use(router);
//------------------------------------------------ Translator
import i18n from "@/middlewares/i18n.js";
app.use(i18n);
//------------------------------------------------ Global Functions
// app.config.globalProperties.isMobile = ()=> /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
//------------------------------------------------ Bootstrap
//------------------------------------------------ Bootstrap
import "jquery/dist/jquery.min.js";
window.$ = window.jQuery = require('jquery')

import "@/assets/bootstrap-5.3.3.min.css";
window.$bootstrap = require('bootstrap');
//------------------------------------------------ Mount App
app.mount('#app')
